module.exports = __webpack_public_path__ + "static/media/GovGig_Logo_Transparent_512.7355baac.png";